import _ from 'lodash';
import API from '@/api';
import * as types from '@/store/mutationTypes';
import { mapGetters } from 'vuex';
import loadGroupMixin from './loadGroupMixin';

export default {
  data() {
    return {
      loadingLoad: false,
    };
  },
  mixins: [
    loadGroupMixin,
  ],
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('dispatchRequests', {
      loadingDispatchRequests: 'loadingLoads',
      dispatchRequestsTime: 'timestamp',
      dispatchRequestsList: 'list',
      storeDispatchRequestsCompanyId: 'companyId',
    }),
    dispatchRequestsCompanyId() {
      return this.storeDispatchRequestsCompanyId;
    },
    dispatchRequestCount() {
      return this.dispatchRequests.length;
    },
    dispatchRequestTruckCount() {
      return this.loadGroupHolderCollectionTruckCount(this.dispatchRequests);
    },
    dispatchRequests() {
      return _.filter(this.dispatchRequestsList,
        dispatch => this.dispatchRequestVisibleCount(dispatch) > 0);
    },
  },
  methods: {
    dispatchRequestAcceptLoadsOptions(dispatch) {
      const dispatchAvailable = this.dispatchRequestVisibleCount(dispatch);
      return _.range(1, dispatchAvailable + 1)
        .map(i => ({ value: i, text: i }));
    },
    loadDispatchedRequests(companyId) {
      this.$store.dispatch('dispatchRequests/getDispatchedRequests', companyId);
    },
    dispatchRequestVisibleCount(dispatch) {
      const available = this.loadGroupAvailableLoadCount(dispatch);
      return _.min([dispatch.visibleCount, available]);
    },
    async refreshLoad(load, companyId) {
      try {
        this.loadingLoad = true;
        const apiResponse = await API.dispatchers.getDispatch(load.humanId, companyId);
        this.$store.dispatch('dispatchRequests/updateLoad', apiResponse.data);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingLoad = false;
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dispatchRequestsMixin.js